
export const ENDPOINTS_PROJECTS = {
  GET_ALL: "/api/projects",
  GET_BY_ID: (id: number) => `/api/projects/${id}`,
  GET_BY_USERAPP_ID: () => `/api/projects/userapp`,
  POST: "/api/projects",
  PUT: (id: number) => `/api/projects/${id}`,
  DELETE: (id: number) => `/api/projects/${id}`,
};

export const ENDPOINTS_LESSON_PROJECT = {
  GET_ALL: "/api/lesson_projects",
  GET_BY_ID: (id: number) => `/api/lesson_projects/${id}`,
  POST: "/api/lesson_projects",
  PUT: (id: number) => `/api/lesson_projects/${id}`,
  DELETE: (id: number) => `/api/lesson_projects/${id}`,
};

// Ajout des endpoints pour lesson_project_condition
export const ENDPOINTS_LESSON_PROJECT_CONDITION = {
  // Endpoint pour vérifier l'éligibilité d'un utilisateur à créer un projet
  CHECK: "/api/lesson-project-condition/check",
};

export const ENDPOINTS_COMMENTS = {
  GET_ALL: "/api/comments", // GET /comments
  GET_BY_ID: (id: number) => `/api/comments/${id}`, // GET /comments/:id
  POST: "/api/comments", // POST /comments
  PUT: (id: number) => `/api/comments/${id}`, // PUT /comments/:id
  DELETE: (id: number) => `/api/comments/${id}`, // DELETE /comments/:id
  GET_BY_USERAPP_ID: () => `/api/comments/user`, // GET /comments/user/:userapp_id
  GET_BY_PROJECT_ID: (projectId: number) => `/api/comments/project/${projectId}`, // GET /comments/project/:project_id
};


export const ENDPOINTS_LIKES = {
  // Pour basculer (toggle) le like/délike sur un projet.
  TOGGLE: (id: number) => `/api/likes/${id}/toggle`,
  // Pour récupérer le nombre de likes d'un projet.
  GET_LIKES_BY_USER_ID: (id: number) => `/api/likes/${id}/users`,
};


// ===================================================
//  PROJECT LIST  (Parent / Animateur)
// ===================================================
export const ENDPOINTS_PROJECT_LIST = {
  GET_PROJECT_LIST: "/api/project-list",
};
export const ENDPOINTS_STORE = {
  GET_SCHOOL: "/api/store/school",
  GET_TILMICODE: "/api/store/tilmicode",
};

